import { useTranslations } from 'use-intl';
import { cashAccountTypeCode } from '@/utils/cashAccountTypeLabel';

/** `cashAccountTypeLabel` worded in the language the app shows; `null` where no badge belongs. */
export function useBankAccountType() {
  const t = useTranslations('consultantBank.cashAccountTypes');
  return (cashAccountType: string | null | undefined): string | null => {
    const code = cashAccountTypeCode(cashAccountType);
    return code ? t(code) : null;
  };
}
